import React from 'react';
import { Input, ValidationMessage } from './';
const FormInput = React.memo((props) => {
    var _a, _b, _c;
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null,
            React.createElement(Input, { inputType: props.inputType, inputValue: props.inputValue, optionClass: `${(_a = props.optionClass) !== null && _a !== void 0 ? _a : ""} -sm:w-full sm:w-4/5`, name: props.name, onChange: props.onChange, disabled: props.disabled, overlayClass: (_b = props.overlayClass) !== null && _b !== void 0 ? _b : "", placeholder: (_c = props.placeholder) !== null && _c !== void 0 ? _c : "" }),
            React.createElement(ValidationMessage, { name: props.name, validationErrors: props.validationErrors }))));
});
export default FormInput;
